import PropTypes from 'prop-types';
import styled from 'styled-components';

const StaticWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  flex-direction: column;
  background-color: transparent !important;
  overflow: hidden;
`;

export const YouStaticWrapper = ({ children }) => (
  <StaticWrapper data-testid="static-wrapper">{children}</StaticWrapper>
);

YouStaticWrapper.propTypes = {
  children: PropTypes.node,
};
